var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 11.4436V8.33247C12.4444 7.68432 12.2176 7.13339 11.7639 6.67969C11.3102 6.22598 10.7593 5.99913 10.1111 5.99913H2.95556L5.75556 8.79913L4.66667 9.88802L0 5.22135L4.66667 0.554688L5.75556 1.64358L2.95556 4.44358H10.1111C11.187 4.44358 12.1043 4.82261 12.8629 5.58069C13.621 6.33928 14 7.25654 14 8.33247V11.4436H12.4444Z",
    fill: "#8A939A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.6a7a31cae6d37bb8b353ddf07f2e85a5.svg";
export { ForwardRef as ReactComponent };